import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M19 19V5L5 19h14zm-2-3.5V17h-5v-1.5h5z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 15.5h5V17h-5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14z"
})), 'IsoTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/IsoTwoTone.js
// module id = 4309
// module chunks = 2